"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TKFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_227)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_227`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.31982 0.000244141H34.6802V23.9998H-1.31982V0.000244141Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.4961 6.261L13.7552 7.0582H14.5932L13.9152 7.55081L14.1742 8.34794L13.4961 7.85526L12.818 8.34794L13.0771 7.55081L12.3989 7.0582H13.2371L13.4961 6.261ZM6.89386 13.8262L7.21765 14.8227H8.2653L7.41768 15.4384L7.74154 16.4349L6.89386 15.819L6.04624 16.4349L6.36996 15.4384L5.52241 14.8227H6.57L6.89386 13.8262ZM8.85417 2.41504L9.17789 3.41151H10.2256L9.37793 4.02731L9.70179 5.02371L8.85417 4.40784L8.00648 5.02371L8.33034 4.02731L7.48272 3.41151H8.53038L8.85417 2.41504ZM3.56969 6.32807L3.89341 7.32454H4.94107L4.09345 7.94034L4.41731 8.93674L3.56969 8.32094L2.722 8.93674L3.04586 7.94034L2.19824 7.32454H3.2459L3.56969 6.32807Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M32.6684 18.9258H6.96318C6.96318 18.9258 14.6437 12.6988 28.8018 3.39111C28.8018 3.39111 22.5831 12.4569 32.6684 18.9258ZM6.96318 19.7405C6.17729 19.7405 6.17603 20.9618 6.96318 20.9618H32.6684C33.4543 20.9618 33.4555 19.7405 32.6684 19.7405H6.96318Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_227`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TKFlag };
